export default "<app-calendario-view-mes></app-calendario-view-mes>\n";